/* Jada Perfumes — Gift Picker
 * كل عطر مدفوع = خانة هدية. السقف = الأقل من (سعر العطر المدفوع، 1200).
 * الخصم نفسه (السعر صفر) بيجي من خصم Buy X Get Y في شوبيفاي.
 */
(function () {
  'use strict';
  if (window.__jadaGiftPicker) return;
  window.__jadaGiftPicker = true;

  var CFG = {
    giftTag: 'gift-eligible', // تاج العطور اللي سعر الـ 100مل بتاعها <= 1200
    boxTag: 'box',            // تاج البوكسات
    maxGiftPrice: 1200,
    giftProp: '_gift',        // خاصية مخفية بتميز سطر الهدية
    currency: 'ج.م',
    t: {
      bar: function (n) { return '🎁 لديك ' + n + (n === 1 ? ' هدية مجانية' : ' هدايا مجانية') + ' لم تُختر — اختار الآن'; },
      title: 'اختار هديتك المجانية!',
      sub: function (cap) { return 'عطور حتى ' + fmt(cap) + ' ' + CFG.currency; },
      size: 'اختار الحجم:',
      add: 'أضف الهدية',
      no: 'لا شكراً',
      none: 'مفيش هدايا متاحة بالحجم ده',
      err: 'حصلت مشكلة، حاول تاني',
      buy: 'اشتري الآن',
      wait: 'جاري التحويل...'
    }
  };

  var _fetch = window.fetch.bind(window); // نسخة أصلية: طلباتنا مش بتشغّل المراقب
  var catalogPromise = null;
  var state = { free: [], cat: null };

  function fmt(n) {
    try { return new Intl.NumberFormat('ar-EG', { maximumFractionDigits: 0 }).format(n); }
    catch (e) { return String(Math.round(n)); }
  }

  /* ---------- الكتالوج ---------- */
  function loadCatalog() {
    if (catalogPromise) return catalogPromise;
    catalogPromise = (async function () {
      var all = [];
      for (var page = 1; page <= 5; page++) {
        var r = await _fetch('/products.json?limit=250&page=' + page);
        if (!r.ok) break;
        var j = await r.json();
        if (!j.products || !j.products.length) break;
        all = all.concat(j.products);
        if (j.products.length < 250) break;
      }
      var byVariant = {};
      var gifts = [];
      all.forEach(function (p) {
        var tags = (Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(','))
          .map(function (s) { return s.trim().toLowerCase(); });
        var info = {
          id: p.id,
          title: p.title,
          image: p.images && p.images[0] ? p.images[0].src : '',
          isBox: tags.indexOf(CFG.boxTag) > -1,
          isGift: tags.indexOf(CFG.giftTag) > -1,
          variants: p.variants.map(function (v) {
            return { id: v.id, price: parseFloat(v.price), label: v.option1 || v.title, available: v.available !== false };
          })
        };
        info.variants.forEach(function (v) { byVariant[v.id] = { product: info, price: v.price }; });
        if (info.isGift && !info.isBox) gifts.push(info);
      });
      return { byVariant: byVariant, gifts: gifts };
    })();
    return catalogPromise;
  }

  /* ---------- منطق الخانات ---------- */
  function analyze(cart, cat) {
    var slots = [], gifts = [];
    cart.items.forEach(function (it) {
      var info = cat.byVariant[it.variant_id];
      if (!info) return;
      var isGiftLine = it.properties && it.properties[CFG.giftProp];
      for (var i = 0; i < it.quantity; i++) {
        if (isGiftLine) {
          gifts.push({ line: it, price: info.price, ok: info.product.isGift && !info.product.isBox });
        } else if (!info.product.isBox) {
          // عطر مؤهل كهدية (في الـ Collection): السقف 1200 لأن شوبيفاي هيخلي الأرخص مجاني.
          // عطر غير مؤهل (غالي): الهدية لازم تكون <= سعره، وإلا هتتحسب هي المجانية وهو المدفوع.
          slots.push(info.product.isGift ? CFG.maxGiftPrice : Math.min(info.price, CFG.maxGiftPrice));
        }
      }
    });
    var free = slots.slice().sort(function (a, b) { return a - b; });
    var invalid = [];
    gifts.sort(function (a, b) { return b.price - a.price; }).forEach(function (g) {
      var idx = -1;
      if (g.ok) { for (var k = 0; k < free.length; k++) { if (free[k] >= g.price) { idx = k; break; } } }
      if (idx === -1) invalid.push(g); else free.splice(idx, 1);
    });
    return { free: free, invalid: invalid };
  }

  function candidates(cat, cap) {
    var out = [];
    cat.gifts.forEach(function (p) {
      p.variants.forEach(function (v) {
        if (v.available && v.price <= cap) out.push({ product: p, variant: v });
      });
    });
    return out;
  }

  async function removeInvalid(cart, invalid) {
    var counts = {};
    invalid.forEach(function (g) { counts[g.line.key] = (counts[g.line.key] || 0) + 1; });
    for (var key in counts) {
      var line = cart.items.filter(function (i) { return i.key === key; })[0];
      await _fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, line.quantity - counts[key]) })
      });
    }
  }

  /* ---------- الواجهة ---------- */
  function h(tag, cls, text) {
    var el = document.createElement(tag);
    if (cls) el.className = cls;
    if (text != null) el.textContent = text;
    return el;
  }

  function injectCss() {
    if (document.getElementById('jgp-css')) return;
    var s = document.createElement('style');
    s.id = 'jgp-css';
    s.textContent =
      '.jgp-bar{position:fixed;left:50%;top:50%;transform:translate(-50%,-50%);z-index:2147483000;background:#b39253;color:#fff;border:2px solid #fff;border-radius:999px;padding:14px 22px;font-family:inherit;font-size:16px;font-weight:700;line-height:1.4;box-shadow:0 8px 28px rgba(0,0,0,.35);cursor:pointer;width:max-content;max-width:calc(100vw - 32px);text-align:center;direction:rtl;animation:jgpPulse 2s ease-in-out infinite}' +
      '@keyframes jgpPulse{0%,100%{transform:translate(-50%,-50%) scale(1)}50%{transform:translate(-50%,-50%) scale(1.04)}}' +
      '.jgp-ov{position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:2147483001;display:flex;align-items:center;justify-content:center;padding:16px;direction:rtl}' +
      '.jgp-box{background:#fff;border-radius:24px;width:100%;max-width:460px;max-height:88vh;display:flex;flex-direction:column;overflow:hidden}' +
      '.jgp-hd{padding:18px 20px;border-bottom:1px solid #eee;display:flex;align-items:center;justify-content:space-between;gap:10px}' +
      '.jgp-hd h3{margin:0;font-size:20px}.jgp-hd p{margin:4px 0 0;color:#888;font-size:13px}' +
      '.jgp-x{background:none;border:0;font-size:24px;cursor:pointer;color:#666}' +
      '.jgp-grid{padding:14px 16px;display:grid;grid-template-columns:1fr 1fr;gap:12px;overflow-y:auto;flex:1}' +
      '.jgp-card{border:2px solid #e8e4da;border-radius:18px;padding:8px;text-align:center;cursor:pointer;position:relative;background:#fff}' +
      '.jgp-card img{width:100%;aspect-ratio:1/1.1;object-fit:cover;border-radius:12px;background:#f1ede4}' +
      '.jgp-card b{display:block;margin-top:6px;font-size:14px}.jgp-card span{color:#999;font-size:13px}' +
      '.jgp-card.on{border-color:#b39253;background:#fbf9f4}' +
      '.jgp-card.on:after{content:"✓";position:absolute;top:12px;left:12px;width:26px;height:26px;border-radius:50%;background:#b39253;color:#fff;line-height:26px;font-size:15px}' +
      '.jgp-sz{padding:8px 16px;display:flex;gap:8px;align-items:center;flex-wrap:wrap}' +
      '.jgp-box button{font-family:inherit}' +
      '.jgp-chip{border:1px solid #ddd;background:#fff;border-radius:999px;padding:8px 18px;cursor:pointer;font-weight:600}' +
      '.jgp-chip.on{background:#b39253;color:#fff;border-color:#b39253}' +
      '.jgp-ft{padding:14px 16px;border-top:1px solid #eee;display:flex;gap:10px}' +
      '.jgp-ft button{flex:1;border-radius:999px;padding:14px;font-weight:700;cursor:pointer;border:1px solid #ddd;background:#fff;color:#777}' +
      '.jgp-ft .go{background:#b39253;color:#fff;border-color:#b39253}.jgp-ft .go[disabled]{opacity:.45;cursor:default}' +
      '.jgp-empty{grid-column:1/-1;text-align:center;color:#999;padding:30px 0}' +
      '.jgp-buy{display:block;width:100%;margin-top:12px;background:#b39253;color:#fff;border:0;border-radius:999px;padding:18px;font-family:inherit;font-size:20px;font-weight:700;line-height:1.2;cursor:pointer}' +
      '.jgp-buy[disabled]{opacity:.6;cursor:default}';
    document.head.appendChild(s);
  }

  function renderBar() {
    var old = document.querySelector('.jgp-bar');
    if (old) old.remove();
    var n = state.free.length;
    if (!n || !state.cat) return;
    var cap = state.free[n - 1];
    if (!candidates(state.cat, cap).length) return;
    injectCss();
    var bar = h('div', 'jgp-bar', CFG.t.bar(n));
    bar.addEventListener('click', function () { openPopup(cap); });
    document.body.appendChild(bar);
  }

  function goCart() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    location.href = root + 'cart';
  }

  function openPopup(cap, buyNowMode) {
    injectCss();
    var cat = state.cat;
    var list = candidates(cat, cap);
    var sizes = [];
    list.forEach(function (c) { if (sizes.indexOf(c.variant.label) < 0) sizes.push(c.variant.label); });
    var size = sizes.filter(function (s) { return /100/.test(s); })[0] || sizes[0];
    var chosen = null;

    var ov = h('div', 'jgp-ov');
    var box = h('div', 'jgp-box');
    var hd = h('div', 'jgp-hd');
    var tx = h('div');
    tx.appendChild(h('h3', null, CFG.t.title));
    tx.appendChild(h('p', null, CFG.t.sub(cap)));
    var x = h('button', 'jgp-x', '×');
    hd.appendChild(tx); hd.appendChild(x);
    var grid = h('div', 'jgp-grid');
    var sz = h('div', 'jgp-sz');
    var ft = h('div', 'jgp-ft');
    var go = h('button', 'go', CFG.t.add); go.disabled = true;
    var no = h('button', null, CFG.t.no);
    ft.appendChild(go); ft.appendChild(no);
    box.appendChild(hd); box.appendChild(grid); box.appendChild(sz); box.appendChild(ft);
    ov.appendChild(box);

    function close() { ov.remove(); if (buyNowMode) goCart(); }
    x.addEventListener('click', close);
    no.addEventListener('click', close);
    ov.addEventListener('click', function (e) { if (e.target === ov) close(); });

    function draw() {
      grid.innerHTML = ''; sz.innerHTML = '';
      sizes.forEach(function (s) {
        var chip = h('button', 'jgp-chip' + (s === size ? ' on' : ''), s);
        chip.addEventListener('click', function () { size = s; chosen = null; go.disabled = true; draw(); });
        sz.appendChild(chip);
      });
      var shown = list.filter(function (c) { return c.variant.label === size; });
      if (!shown.length) grid.appendChild(h('div', 'jgp-empty', CFG.t.none));
      shown.forEach(function (c) {
        var card = h('div', 'jgp-card' + (chosen && chosen.id === c.variant.id ? ' on' : ''));
        if (c.product.image) { var im = h('img'); im.src = c.product.image; im.alt = c.product.title; card.appendChild(im); }
        card.appendChild(h('b', null, c.product.title));
        card.appendChild(h('span', null, fmt(c.variant.price) + ' ' + CFG.currency));
        card.addEventListener('click', function () { chosen = c.variant; go.disabled = false; draw(); });
        grid.appendChild(card);
      });
    }

    go.addEventListener('click', async function () {
      if (!chosen) return;
      go.disabled = true;
      try {
        var props = {}; props[CFG.giftProp] = '1';
        var r = await _fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: chosen.id, quantity: 1, properties: props }] })
        });
        if (!r.ok) throw new Error('add failed');
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        location.href = root + 'cart';
      } catch (e) { go.disabled = false; alert(CFG.t.err); }
    });

    draw();
    document.body.appendChild(ov);
  }

  /* ---------- المزامنة ---------- */
  var running = false, timer = null;
  function schedule() { clearTimeout(timer); timer = setTimeout(run, 400); }

  async function run() {
    if (running) return;
    running = true;
    try {
      var cart = await (await _fetch('/cart.js')).json();
      if (!cart.items || !cart.items.length) { state.free = []; renderBar(); return; }
      var cat = await loadCatalog();
      var res = analyze(cart, cat);
      if (res.invalid.length) {
        await removeInvalid(cart, res.invalid);
        location.reload();
        return;
      }
      state.free = res.free; state.cat = cat;
      renderBar();
    } catch (e) { console.warn('[gift-picker]', e); }
    finally { running = false; }
  }

  /* ---------- زر اشتري الآن (بديل لزر الثيم) ---------- */
  async function buyNow(btn) {
    var form = document.querySelector('form[action*="/cart/add"]');
    var idEl = form && form.querySelector('[name="id"]');
    var id = idEl && idEl.value;
    if (!id) { var m = location.search.match(/variant=(\d+)/); id = m && m[1]; }
    var qEl = form && form.querySelector('[name="quantity"]');
    var qty = Math.max(1, parseInt(qEl && qEl.value, 10) || 1);
    if (!id) { alert(CFG.t.err); return; }
    var label = btn.textContent;
    btn.disabled = true; btn.textContent = CFG.t.wait;
    try {
      var r = await _fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] })
      });
      if (!r.ok) throw new Error('add failed');
      await run();
      var n = state.free.length;
      if (n && state.cat && candidates(state.cat, state.free[n - 1]).length) {
        btn.disabled = false; btn.textContent = label;
        openPopup(state.free[n - 1], true);
      } else {
        goCart();
      }
    } catch (e) {
      btn.disabled = false; btn.textContent = label;
      alert(CFG.t.err);
    }
  }

  function mountBuyNow() {
    if (location.pathname.indexOf('/products/') === -1) return;
    if (document.querySelector('.jgp-buy')) return;
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    injectCss();
    var btn = h('button', 'jgp-buy', CFG.t.buy);
    btn.type = 'button';
    btn.addEventListener('click', function () { buyNow(btn); });
    var host = form.closest('product-form-component') || form;
    host.parentNode.insertBefore(btn, host.nextSibling);
  }

  var mountTimer = null;
  function watchMount() {
    mountBuyNow();
    new MutationObserver(function () {
      clearTimeout(mountTimer);
      mountTimer = setTimeout(mountBuyNow, 300);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  // مراقبة أي تغيير في السلة من الثيم
  window.fetch = function () {
    var a = arguments;
    var url = typeof a[0] === 'string' ? a[0] : (a[0] && a[0].url) || '';
    var p = _fetch.apply(window, a);
    if (/\/cart\/(add|change|update|clear)/.test(url)) { p.then(schedule).catch(function () {}); }
    return p;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(); watchMount(); });
  } else {
    run(); watchMount();
  }
})();